import * as Yup from "yup";
import { Formik } from "formik";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import React, { Fragment, useEffect, useState } from "react";
import { DialogContent, Dialog, Grid, Typography } from "@mui/material";

import CreativeForm from "./CreativeForm";
import { creative } from "../campaignObject";
import { useAxios, useComponent } from "../../../../hooks";
import {
  PrimaryButton,
  CancelButton,
  PrimaryLoadingButton,
  CancelLoadingButton,
} from "../../../css components/Button";

const Card = styled(Dialog)`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`;

const Note = styled(Typography)`
  font-weight: 500;
  font-size: 16px;
  line-height: 33px;
  color: rgb(255 75 75);
  margin-left: 10px;
`;

export default function CreativeDialog({
  editState,
  setEditState,
  detail,
  setDetail,
  formikProps,
  component,
}) {
  const axios = useAxios();
  const dispatch = useDispatch();
  const { alert } = useComponent();

  const [adSize, setAdSize] = useState([]);
  const [confirm, setConfirm] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleClose = () => {
    setDetail({ state: false, data: {}, id: "" });
  };

  useEffect(() => {
    axios({
      url: "/adserver/listAdTypeForChannel",
    })
      .then((response) => {
        if (response.success) {
          setAdSize(response.adTypes.items);
        }
      })
      .catch((error) => {});
  }, [axios]);

  return (
    <Card
      open={detail.state}
      onClose={handleClose}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "800px!important",
        },
      }}
    >
      <Formik
        enableReinitialize
        initialValues={detail.data}
        validationSchema={creativeSchema}
        validateOnChange
        onSubmit={(formData, { setSubmitting }) => {
          setSubmitLoading(true);
          let url = "/user/brand/campaign/creatives/";
          let method = "POST";
          if (!!detail.id) {
            url =
              "/user/brand/campaign/creatives?creativeId=" +
              formData.creativeID;
            method = "PUT";
          }

          axios({
            url: url,
            method: method,
            disableRedirect: true,
            data: creative(
              formData,
              detail.campaignDetails.campaignID,
              detail.data
            ),
          }).then((response) => {
            if (response.success) {
              if (!!detail.id) {
                dispatch(alert.success("Creative updated Successfully!"));

                formikProps.setValues((prev) => ({
                  ...prev,
                  creatives: setCreative(prev.creatives),
                }));

                function setCreative(creative) {
                  for (let create of creative) {
                    if (create.creativeID === formData.creativeID) {
                      create.fileUrl = response.data.url;
                      create.creative = response.data.file_path;
                      create.fileName = response.data.file_path;
                      create.creativeID = response.data.creative_id;
                      create.format = response.data.banner_format;
                      create.friendlyName = response.data.creative_name;
                      create.adSize = response.data.banner_size;
                      create.adTag = response.data.ad_tag || "";
                      create.destination_url = response.data.destination_url;
                      create.destinationURLCheckbox =
                        response.data.same_as_campaign_url;
                      create.isDeleted = response.data.is_deleted;
                      create.upload = response.data.banner_type;
                    }
                  }
                  return creative;
                }
              } else {
                dispatch(alert.success("Creative Created Successfully!"));

                formikProps.setValues((prev) => ({
                  ...prev,
                  creatives: [
                    ...prev.creatives,
                    {
                      creativeID: response.data.creative_id,
                      format: response.data.banner_format,
                      creative: response.data.file_path,
                      fileUrl: response.data.url,
                      friendlyName: response.data.creative_name,
                      fileName: response.data.file_path,
                      adSize: response.data.banner_size,
                      adTag: response.data.ad_tag || "",
                      destination_url: response.data.destination_url,
                      destinationURLCheckbox:
                        response.data.same_as_campaign_url,
                      isDeleted: response.data.is_deleted,
                      upload: response.data.banner_type,
                    },
                  ],
                }));
              }

              handleClose();
              setSubmitLoading(false);
            } else {
              setSubmitLoading(false);
            }
          });
          setSubmitting(false);
        }}
      >
        {(dialogFormikProps) => (
          <DialogContent>
            <Grid container spacing={3} style={{ padding: "20px" }}>
              <CreativeForm
                isValidated={isValidated}
                setIsValidated={setIsValidated}
                formikProps={formikProps}
                dialogFormikProps={dialogFormikProps}
                editState={editState}
                setEditState={setEditState}
                handleClose={handleClose}
                component={component}
                adSize={adSize}
                confirm={confirm}
                setConfirm={setConfirm}
              />
              <Grid item xs={12}>
                <Note>
                  {`NOTE : Ad format, and uploaded image can not be edited ${
                    !dialogFormikProps.values.creativeID ? "once saved" : ""
                  }.                      `}
                </Note>
              </Grid>
              {component !== "superadmin" && component !== "request" && (
                <Fragment>
                  {editState ? (
                    <Grid item>
                      <PrimaryLoadingButton
                        variant="contained"
                        type="submit"
                        disabled={
                          !dialogFormikProps.isValid || !dialogFormikProps.dirty
                        }
                        loading={submitLoading}
                        onClick={dialogFormikProps.handleSubmit}
                      >
                        Save
                      </PrimaryLoadingButton>
                    </Grid>
                  ) : (
                    <Grid item>
                      <PrimaryButton
                        variant="contained"
                        onClick={() => setEditState(!editState)}
                      >
                        Edit Creative
                      </PrimaryButton>
                    </Grid>
                  )}
                  <Grid item>
                    <CancelButton variant="outlined" onClick={handleClose}>
                      Cancel
                    </CancelButton>
                  </Grid>
                  <Grid item xs={5.65} textAlign="end">
                    {component !== "superadmin" &&
                      component !== "request" &&
                      dialogFormikProps.values.creativeID && (
                        <CancelLoadingButton
                          variant="contained"
                          onClick={onDelete}
                          style={{ color: "white", background: "red" }}
                        >
                          Deactivate
                        </CancelLoadingButton>
                      )}
                  </Grid>
                </Fragment>
              )}
            </Grid>
          </DialogContent>
        )}
      </Formik>
    </Card>
  );

  function onDelete() {
    setConfirm(true);
  }
}

const creativeSchema = Yup.object().shape({
  format: Yup.string().required("Please select format"),

  friendlyName: Yup.string().required("Give creative a name"),

  adSize: Yup.string().when("format", {
    is: (val) => val !== "ad-tag",
    then: Yup.string().required("Fill the field"),
  }),

  adTag: Yup.string().when("format", {
    is: (val) => val === "ad-tag",
    then: Yup.string().required("Fill the field"),
  }),

  upload: Yup.mixed().when("format", {
    is: (val) => val !== "ad-tag",
    then: Yup.mixed().required("Select Source Type"),
  }),
  fileUrl: Yup.string().when("upload", {
    is: (val) => val === "link",
    then: Yup.string().required("Please enter a URL"),
  }),

  fileName: Yup.string().when("upload", {
    is: (val) => val === "local",
    then: Yup.string().required("Please upload a file"),
  }),

  destination_url: Yup.string()
    .matches(
      /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)[a-zA-Z0-9:@%._?=/-]{2,}(\.[a-zA-Z0-9:@%._?=/-]{2,})(\.[a-zA-Z0-9:@%._?=/-]{2,})?/,
      "Enter correct url!"
    )
    .required("Destination URL is required"),
});
